import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppButton from "../../../components/AppButton";
import AppDialog from "../../../components/AppDialog";
import Rocket from "../../../assets/logo/rocket.svg";
import { Container } from "@mui/system";
import config from "../../../utils/config";
import { fiatVendors, paymentOptions } from "../../../utils/constants";
import { logEvent } from "../../../store/api";
import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS } from "../../../utils/events";
import { useLocation } from 'react-router-dom'; 
import { useSelector } from "react-redux";
import { HelpOutline } from "@mui/icons-material";

export default function KycPending({
  showKyt,
  setShowKyt,
  active,
  handleVerification,
  payment
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(({ Auth }) => Auth?.user || {});

  const handleVerificationStarted = ()=>{

      const pathArr = location.pathname.split('/');
      let source = ACTIVITY_META.KYC.AFTER_TRANSFER
      if(Number(pathArr[pathArr.length-1]) > 0){
        source = ACTIVITY_META.KYC.AFTER_CRYPTO;
      }
    if (user?.userType?.toString() === '1') {
      logEvent({
        current: EVENTS.KYB.KYB_STARTED,
        activity: ACTIVITY_DETAIL.KYB.KYB_STARTED,
        meta: {
          data: {
            pathname: location.pathname,
            source
          }
        }
      })
    }else{
      logEvent({
        current: EVENTS.KYC.KYC_STARTED,
        activity: ACTIVITY_DETAIL.KYC.KYC_STARTED,
        meta: {
          data: {
            pathname: location.pathname,
            source
          }
        }
      })
    }
     
      handleVerification()
    
  }
  return (
    <AppDialog show={showKyt} onChangeShow={setShowKyt} showClose={false}>
      <Container
        maxWidth="xs"
        sx={{
          display: "flex",
          flexFlow: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: 4
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexFlow: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <Rocket style={{ width: 84 }} />
        </Box>
        <Box paddingLeft={3} paddingRight={3} marginBottom={5}>
          <Typography
            color={"#D4D4D8"}
            fontWeight={700}
            fontSize={20}
            textAlign="center"
          >
            {t("homepage.kycTitle")}
          </Typography>
          <Typography
            variant="subtitle1"
            color={"#D4D4D8"}
            fontSize={16}
            fontWeight={400}
            marginTop={1}
            textAlign="center"
          >
            {t("kyc.incomplete1")}
          </Typography>
        </Box>
        <Box width='100%'>
          <AppButton
            buttontheme={"light"}
            title={t("kyc.completeins")}
            onClick={handleVerificationStarted}
          />
          {(active === 0) && (
            <AppButton
              buttontheme={"transparent"}
              sx={{ marginTop: 2, width: "100%" }}
              onClick={() => setShowKyt(false)}
              title={t("remindLater")}
            />
          )}
          {((active === 3 && payment === paymentOptions.crypto) || (active === 2 && fiatVendors.includes(payment)) ) && (
            <AppButton
              buttontheme={"transparent"}
              sx={{ marginTop: 2, width: "100%" }}
              onClick={() => navigate("/home")}
              title={t("back")}
            />
          )}
        </Box>
        <Link
          href={config.KYC_WHY}
          target="_blank"
          rel="noreferrer"
          color={"#0088F5"}
          underline="always"
          sx={{
            position: "relative",
            marginTop: "50%",
            fontSize: 14,
            fontWeight: 700,
            textTransform: "capitalize",
            lineHeight: "20px",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            textDecoration: "none",
            "&:visited": { color: "#0088F5" },
            "&:hover": { color: "#0088F5", textDecoration: "underline" },
          }}
        >
          <HelpOutline sx={{ fontSize: 25 }} />
          {t("kyc.learnWhy")}
        </Link>
      </Container>
    </AppDialog>
  );
}
